// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tree-container {\n  height: 75vh;\n}\n.tree-container .node {\n  fill: grey !important;\n}\n.tree-container .link {\n  stroke-width: 2px !important;\n  fill: transparent !important;\n  stroke: #cecece !important;\n}", ""]);
// Exports
module.exports = exports;
